import AndRuleSpecification from 'kaspi.frontend/src/modules/ruleSpecification/AndRuleSpecification'
import IsAvailableLogAnalyticEvent from '@/rules/IsAvailableLogAnalyticEvent'
import IsMobileApp from '@/rules/IsMobileApp'
import { KASPI } from '@/config'

export function sendAnalyticEvent (evenName, params) {
  if ((new AndRuleSpecification(new IsMobileApp(), new IsAvailableLogAnalyticEvent())).isSatisfiedBy(KASPI.mobapp)) {
    const jsonEvent = {
      event: evenName,
      parameters: params
    }
    KASPI.mobapp.logAnalyticEvent(JSON.stringify(jsonEvent))
  }
}
